import {useEffect, useState} from "react";
import Header from "./Header";
import Loading from "./Loading";
import {Clock, DoorClosedIcon, DoorOpen, Files, Info, LogOut, LogOutIcon, StickyNote, Upload, X} from "lucide-react";
import {useNavigate} from "react-router-dom";
import {BsPatchQuestion, BsSticky} from "react-icons/bs";
import {CiLogout} from "react-icons/ci";
import {GrLogout, GrNotes} from "react-icons/gr";
import {HiLogout} from "react-icons/hi";

function SuggestedEditorialAction() {

    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);


    // useEffect(() => {
    //     setLoading(true);
    //     SuggestedEditorialAction(true)
    //         .then(response => {
    //             if (response) {
    //             }
    //             setLoading(false);
    //         })
    //         .catch(() => {
    //             setLoading(false);
    //         });
    // }, [])

    return (
        <div>
            <Header page="home"/>
            {loading ?
                <Loading/>
                :
                <div className="body">
                    <div className="heading">Suggested Editorial Action</div>
                    <div className={"dashboard-row export-score-text"}>
                        Based on scoring and similarity, we recommend rejecting this manuscript.
                        You can confirm, revise, or flag it for later review.
                    </div>
                    <div className="suggested-editorial-action-card border max-width-400 export-score-text">
                        <X size={30} className={"suggested-editorial-action-card-icon"}/>
                        <div className={"suggested-editorial-action-card-text"}>
                            <div>Lacks novelty - Score 42</div>
                            <div>(Threshold: 65)</div>
                        </div>
                    </div>
                    <div className="suggested-editorial-action-card border max-width-400 export-score-text">
                        <Info size={30} className={"suggested-editorial-action-card-icon"}/>
                        <div className={"suggested-editorial-action-card-text"}>
                            <div>High similarity to prior work</div>
                            <div>(>60%)</div>
                        </div>
                    </div>
                    <div className="suggested-editorial-action-card border max-width-400 export-score-text">
                        <BsPatchQuestion size={30} className={"suggested-editorial-action-card-icon"}/>
                        <div className={"suggested-editorial-action-card-text"}>
                            <div>Methodical contribution unclear</div>
                            <div></div>
                        </div>
                    </div>
                    <div className="suggested-editorial-action max-width-400 export-score-text">
                        <LogOut size={24} className={"suggested-editorial-action-card-icon"}/>
                        <div className={"suggested-editorial-action-card-text"}>
                            <div>Reject</div>
                        </div>
                    </div>
                    <div className="suggested-editorial-action max-width-400 export-score-text">
                        <Clock size={24} className={"suggested-editorial-action-card-icon"}/>
                        <div className={"suggested-editorial-action-card-text"}>
                            <div>Put on Hold</div>
                        </div>
                    </div>
                    <div className="suggested-editorial-action max-width-400 export-score-text">
                        <Files size={24} className={"suggested-editorial-action-card-icon"}/>
                        <div className={"suggested-editorial-action-card-text"}>
                            <div>Add Note</div>
                        </div>
                    </div>
                    <div className="suggested-editorial-action max-width-400 export-score-text">
                        <Upload size={24} className={"suggested-editorial-action-card-icon"}/>
                        <div className={"suggested-editorial-action-card-text"}>
                            <div>Save as Draft</div>
                        </div>
                    </div>
                    <div className={"search-bar-wrapper dashboard-row"}>
                        <div className={"submissions-input-half submissions-input-half-first"}>
                            <span className={"dropdown-text"} style={{right: 0}}>Export</span>
                        </div>
                        <div className={"submissions-input-half"}>
                            <span className={"dropdown-text"} style={{right: 0}}>Copy Summary</span>
                        </div>
                    </div>
                </div>
            }
        </div>
    );
}

export default SuggestedEditorialAction;
